import styled from 'styled-components'

interface IDividerProps {
  margin?: string
}

export const Divider = styled.div<IDividerProps>`
  width: 100%;
  height: 1px;
  background-color: #1f2124;
  margin: ${(props) => (props.margin ? props.margin : '0px')};
`

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: auto;
  padding: 0 3.5% 3.5% 0%;
  margin-bottom: 40px;
`

export const TitleContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  gap: 20px;
  background-color: #eff3fa;
  padding: 2% 0 0 0;
`

export const TitleIcon = styled.img`
  width: 65px;
  height: 50px;
  margin-left: 30px;
`

export const StepsContainer = styled.div`
  display: flex;
  width: 100%;
  height: 3%;
  padding: 3% 0% 1% 0%;
  background-color: #eff3fa;
`

interface IRowProps {
  width?: string
  justify?: string
  height?: string
  margin?: string
  gap?: string
}

export const Row = styled.div<IRowProps>`
  display: flex;
  flex-direction: row;
  width: ${(props) => (props.width ? props.width : '100%')};
  justify-content: ${(props) => (props.justify ? props.justify : 'flex-start')};
  height: ${(props) => (props.height ? props.height : 'auto')};
  align-items: center;
  margin: ${(props) => (props.margin ? props.margin : '0px')};
  gap: ${(props) => (props.gap ? props.gap : '0px')};
`

export const DescriptionContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 80%;
  margin: 20px 0px 60px 10px;
`

export const NextButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  margin-top: 10px;
  justify-content: space-between;
  align-items: flex-end;
`

export const TextAreaContainer = styled.div`
  position: relative;
  width: 90%;
`

export const TextArea = styled.textarea`
  font-family: 'Public Sans';
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  width: 100%;
  height: 120px;
  padding: 15px;
  padding-bottom: 35px;
  background: #ffffff;
  border: 1px solid rgba(145, 158, 171, 0.2);
  box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  resize: none;
  &:focus {
    outline: none;
  }
`

export const SkillsContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin: 20px 0px 60px 10px;
  gap: 20px;
`

export const EachSkillContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 80%;
  position: relative;
  margin-bottom: 30px;
  padding: 20px;
  border: 1px solid #eaeaea;
  border-radius: 8px;
`

export const SkillsTitleContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 20px;
  gap: 20px;
  width: 40%;
`

export const DeleteContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 10px;
  position: absolute;
  top: 10px;
  right: 10px;
  cursor: pointer;
  color: #e44646;
  font-size: 13px;
  font-weight: 700;
`

export const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  width: 90%;
  padding: 40px;
`

export const ModalHeader = styled.div`
  display: flex;
  flex-direction: column;
  align-items: left;
  width: 90%;
  margin-bottom: 24px;
  gap: 20px;
`

export const ButtonsContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  margin: 40px 30px 20px 30px;
`

export const QuestionsContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 10px;
  margin: 20px 0 10px 40px;
`

export const QuestionItem = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  padding: 12px 16px;
  border-radius: 8px;
`

export const QuestionNumber = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 20px;
  width: 90%;
`

export const DeleteButton = styled.div`
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #e44646;
  gap: 10px;
  font-size: 13px;
  font-weight: 700;
`

export const QuestionIndicator = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  background-color: #ffffff;
  border-radius: 8px;
  padding: 10px 15px;
  margin-top: 20px;
  gap: 12px;
  width: fit-content;
  box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.1);
`

export const QuestionCircleIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background-color: #eff3fa;
  color: #2d749c;
`

export const EditButtonContainer = styled.div`
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  color: #2d749c;
  margin-left: 15px;
  font-weight: 700;
  gap: 5px;

  &:hover {
    opacity: 0.8;
  }
`

export const TextCardContainer = styled.div`
  display: flex;
  flex-direction: column;
`

export const CharCounter = styled.div<{ isExceeded: boolean }>`
  position: absolute;
  bottom: 8px;
  right: 15px;
  font-size: 12px;
  color: ${(props) => (props.isExceeded ? '#e53935' : '#666')};
  pointer-events: none;
`

export const TrashIconBig = styled.img`
  width: 70px;
  height: 70px;
`

export const TrashIconWhite = styled.img`
  width: 20px;
  height: 25px;
`
